import type { RouteRecordRaw } from 'vue-router';

export const jobsRoute: RouteRecordRaw = {
  path: '/jobs',
  name: 'Jobs',
  component: () => import('./pages/JobsPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('hv:core:jobs:list'),
  },
};
